// Fully static, prerendered SPA — no SSR, no per-request data loading.
export const prerender = true;
export const ssr = false;
